module.exports = __webpack_public_path__ + "img/panela.ab71cbb0.png";